export default __webpack_public_path__ + "static/media/office2-afterA-1440w.60f38b00.png";